import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dashboardGadgetRefreshButtonText: {
		id: 'spa-apps.dashboard.gadget.refresh',
		defaultMessage: 'Refresh',
		description: 'Refresh all gadgets',
	},
});
